// extracted by mini-css-extract-plugin
module.exports = {"calendar-table":"FundDetailsCalendarTab_calendar-table__h5BXO"};